/** @jsx jsx */
/* eslint-disable no-use-before-define */
import React from 'react'
import { jsx, css } from '@emotion/core'
import { mediaQueries, getId } from '../../../twd'
import SearchManual from './search-manual'
import SearchSector from './search-sector'
import DatePicker from '../date-picker'
import useMarketNews from '../use-market-news'

export default ({isModal}) => {

    const { customSearchType, setCustomSearchType, customKeyword, setCustomKeyword, } = useMarketNews()
    let isKeyword = customSearchType === 'keyword'
    let id = getId()

    React.useEffect(() => {
        let _id = id+ '-search-type-'+ (isKeyword ? 'keyword' : 'company')
        let el = document.getElementById(_id)

        if (!el) return
        el.checked = true
    })

    return <React.Fragment>
    <div className="vertical-offset-xs"
        style={{
            padding:'10px',
            backgroundColor:"#f6f6f6"
        }}>
    <div className="row">
    <div className="col-md-10 col-xs-12">

        <div className="form-horizontal"  css={formCss}>

        <div className="col-md-4">

            <div className="radio radio-inline">
            <input type="radio"
                id={id + '-search-type-company'}
                name="corporates-market-news-custom-search-type"
                defaultChecked={!isKeyword}
                onChange={() => {
                    setCustomSearchType('company')
                }}
            />
            <label htmlFor={id + '-search-type-company'}>Company</label>
            </div>

            <div className="radio radio-inline">
            <input type="radio"
                id={id + '-search-type-keyword'}
                name="corporates-market-news-custom-search-type"
                defaultChecked={isKeyword}
                onChange={() => {
                    setCustomSearchType('keyword')
                }}
            />
            <label htmlFor={id + '-search-type-keyword'}>Keyword</label>
            </div>
        </div>

        <div className="form-group col-md-3" style={{marginBottom:0}}>
        <label
            htmlFor={id + (isKeyword ? '-keyword' : '-company') + '-input'}
        >{isKeyword? 'Keyword' : 'Company'}</label>
        {
            isKeyword
            ? <input
                type="text"
                id={id+ '-keyword-input'}
                className="form-control"
                value={customKeyword}
                onChange={(e) => {
                    setCustomKeyword(e.target.value)
                }}
            >
            </input>
            : <SearchManual
                id={id + '-company-input'}
            />
        }

        </div>

        <label className="control-label col-md-1 col-xs-12"
            css={labelCss}>or</label>

        <SearchSector className='col-md-3' isModal={isModal} />

        </div>
    </div>

    <div className="col-md-2 col-xs-12">
        <DatePicker
            dataName="corporates-market-news-custom-search-date-range"
            type="custom"
            size={10} />
    </div>

    </div></div>
    </React.Fragment>
}
const labelCss = css`
    ${mediaQueries.xs} {
        text-align:center;
    }
    ${mediaQueries.notXs} {
        margin-top: 20px;
    }
`

const formCss = css`
    .control-label { text-align:center; }
    ${mediaQueries.xs} {
        .radio, .radio-inline { padding-bottom: 5px; }
    }
    ${mediaQueries.sm} {
        .radio, .radio-inline { padding-bottom: 5px; }
    }
    ${mediaQueries.sm} {
        .radio, .radio-inline { padding-bottom: 5px; }
    }
    ${mediaQueries.notXs} {
        .radio, .radio-inline { margin-top: 15px; }
    }

`





// WEBPACK FOOTER //
// ./src/corporates/market-news/custom-search/custom-search.js